export const DurovaData = [
    {
        title: "дом №13",
        year: '1962',
        floor: "2",
        apartment: "16",
        quantityLC: "16",
        livingArea: "561,6",
        notLivinigArea: "нет",
        commonProperty: "42,6",
        type: "многоэтажный жилой дом",
        level: "отопление,  газоснабжение, электроснабжение",
        technicalSupport: "нет",
        contractURL: 'durova/sofrino_durova_13_dogovor.pdf',
        protocolURL: 'protocol_4_2017-02-16.pdf',
    },

    {
        title: "дом №17",
        year: '1958',
        floor: "1",
        apartment: "7",
        quantityLC: "7",
        livingArea: "218,9",
        notLivinigArea: "нет",
        commonProperty: "0",
        type: "многоэтажный жилой дом",
        level: "отопление,  газоснабжение, электроснабжение",
        technicalSupport: "нет",
        contractURL: 'durova/sofrino_durova_17_dogovor.pdf',
        protocolURL: 'protocol_4_2017-02-16.pdf',
    }

]